import { useEffect, useState } from "react";

// Hook to check if the IMS is ready
function useIMSReady() {
  const [isIMSReady, setIsIMSReady] = useState(
    window.adobeIMS?.initialized || false,
  );

  useEffect(() => {
    const onIMSReady = () => {
      setIsIMSReady(true);
    };
    window.addEventListener("adobeIMS:profileReady", onIMSReady);
    return () => {
      window.removeEventListener("adobeIMS:profileReady", onIMSReady);
    };
  }, []);

  return [isIMSReady];
}

export default useIMSReady;
